function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg090Comoros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.008,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.002,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 128,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "256,256.008 0,512 0,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M65.192,256c0-30.638,21.532-56.232,50.286-62.512c-4.42-0.965-9.005-1.488-13.714-1.488   c-35.347,0-64,28.653-64,64s28.653,64,64,64c4.71,0,9.295-0.523,13.714-1.488C86.725,312.232,65.192,286.638,65.192,256z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "114.773,201.143 118.177,211.62 129.192,211.62 120.28,218.094 123.685,228.571    114.773,222.097 105.86,228.571 109.265,218.094 100.352,211.62 111.368,211.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "114.773,228.571 118.177,239.048 129.192,239.048 120.28,245.523 123.685,256    114.773,249.525 105.86,256 109.265,245.523 100.352,239.048 111.368,239.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "114.773,256 118.177,266.477 129.192,266.477 120.28,272.952 123.685,283.429    114.773,276.954 105.86,283.429 109.265,272.952 100.352,266.477 111.368,266.477  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "114.773,283.429 118.177,293.906 129.192,293.906 120.28,300.38 123.685,310.857    114.773,304.382 105.86,310.857 109.265,300.38 100.352,293.906 111.368,293.906  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg090Comoros);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };